import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '../Services/auth';
import { AlertService } from '../Services/alert';
import { CartService } from '../Services/cart';
import { UserService } from '../Services/user';
import { ProductService } from '../Services/product';
import { ImageUtils } from '../Services/imageutils';
import { Product } from '../Models/product';


@Component({
  selector: 'product-summary',
  templateUrl: '../Templates/product.summary.html',
  styleUrls: ['../Styles/product.summary.scss'],
})


export class ProductSummaryComponent {

  @Input()
  public product: Product;

  constructor (
    private productService: ProductService,
    private alertService: AlertService,
    private authService: AuthService,
    private userService: UserService,
    private cartService: CartService,
    public imageUtils: ImageUtils
  ) { }

  canFollow(): boolean {

    //return this.authService.getUser() &&
    return this.product._links.follow != undefined;
  }

  canUnFollow(): boolean {

    return this.product._links.unfollow != undefined;
  }

  follow(): void {

    this.productService.follow(this.product).subscribe(
      product => {
        this.product = product;
        this.userService.following(product);
        this.alertService.success("Product added to wishlist")
      },
      err => {
        this.alertService.error("Could not add to wishlist")
      }
    );
  }

  unFollow(): void {

    this.productService.unFollow(this.product).subscribe(
      product => {
        this.product = product;
        this.userService.unfollowing(product);
        this.alertService.success("Product removed from wishlist")
      },
      err => {
        this.alertService.error("Could not remove from wishlist")
      }
    );
  }

  /**
   * Add the product to the cart, and refresh local reference.
   */
  addToCart(): void {

    this.cartService.addProduct(this.product).subscribe(
      data => {
        this.productService.get(this.product.id).subscribe(
          product => { this.product = product }
        )

        this.alertService.success("Product added to cart");
      },
      err => {
        if (err.name == "TimeoutError") {
          this.alertService.error("Your connection is slow! Please be patient");
        } else {
          this.alertService.error("Could not add to cart");
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/product.summary.ts